import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { DismissibleRecommendationType, hideRecommendation } from '../../../actions/spaces/HideRecommendationAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const HideRecommendationAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.HideRecommendation,
  translateName: Messages.hide_recommendation_action,
  isVisible: () => true,
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return hideRecommendation(targetItems[0].id,
                              targetItems[0].contentType as DismissibleRecommendationType,
                              targetItems[0].name);
  }
};
